import CategoryService from '@/lib/Category';
import { useQuery } from '@tanstack/react-query';
import useCurrentUser from './useCurrentUser';

export default function useCategories() {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['categories'],
        queryFn: () => CategoryService.getCategories(),
        enabled: !!user,
        staleTime: 5 * 60 * 60 * 1000, // 5 hours
        refetchOnWindowFocus: false,
    });

    return query;
}